export default class Contact {

    constructor() {
        this.salutation = "";
        this.firstname = "";
        this.lastname = "";
        this.email = "";
        this.phone = "";
        this.fax = "";
    }
}